<script setup lang="ts">
import { type HTMLAttributes, computed } from 'vue';
import { DropdownMenuCheckboxItem, type DropdownMenuCheckboxItemEmits, type DropdownMenuCheckboxItemProps, DropdownMenuItemIndicator, useForwardPropsEmits } from 'radix-vue';
import { Check } from 'lucide-vue-next';
import { cn } from '@/lib/utils';

const props = withDefaults(defineProps<DropdownMenuCheckboxItemProps & { class?: HTMLAttributes['class']; indicatorRight?: boolean }>(), {
    class: undefined,
    indicatorRight: false,
});
const emits = defineEmits<DropdownMenuCheckboxItemEmits>();

const delegatedProps = computed(() => {
    const { class: _, indicatorRight: __, ...delegated } = props;

    return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
    <DropdownMenuCheckboxItem
        v-bind="forwarded"
        :class="
            cn(
                'relative flex cursor-default select-none truncate items-center rounded-md py-2 text-normal outline-none transition-colors focus:bg-gray-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
                props.indicatorRight ? 'pl-3 pr-9' : 'pl-8 pr-3',
                props.class
            )
        "
    >
        <span :class="cn('absolute flex h-3.5 w-3.5 items-center justify-center', props.indicatorRight ? 'right-2' : 'left-2')">
            <DropdownMenuItemIndicator>
                <Check class="w-4 h-4" />
            </DropdownMenuItemIndicator>
        </span>
        <slot />
    </DropdownMenuCheckboxItem>
</template>
